<div class="row">
  <div class="col col-12 p-0" #chartRatingContainer>
    <ngx-charts-bar-vertical-stacked [view]="view" [scheme]="colorScheme" [results]="ratingsPerMonth"
      [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend"
      [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel" [showGridLines]="showGridLines"
      [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" [animations]="animations"
      [maxXAxisTickLength]="maxXAxisTickLength" [trimXAxisTicks]="trimXAxisTicks" [rotateXAxisTicks]="rotateXAxisTicks">
    </ngx-charts-bar-vertical-stacked>
  </div>
</div>
<div class="row pt-3">
  <div class="col col-12">
    <p class="text-3 mb-3 text-center text-primary">Audit ratings by month</p>
  </div>
</div>